/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateRegionRequest,
  HTTPValidationError,
  RegionResponse,
  UpdateRegionRequest,
} from '../models/index';
import {
    CreateRegionRequestFromJSON,
    CreateRegionRequestToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    RegionResponseFromJSON,
    RegionResponseToJSON,
    UpdateRegionRequestFromJSON,
    UpdateRegionRequestToJSON,
} from '../models/index';

export interface CreateRegionApiRegionsPostRequest {
    createRegionRequest: CreateRegionRequest;
    xApiKey?: string | null;
}

export interface DeleteRegionApiRegionsRegionIdDeleteRequest {
    regionId: number;
    xApiKey?: string | null;
}

export interface GetRegionApiRegionsRegionIdGetRequest {
    regionId: number;
    xApiKey?: string | null;
}

export interface GetRegionsApiRegionsGetRequest {
    xApiKey?: string | null;
}

export interface UpdateRegionApiRegionsRegionIdPutRequest {
    regionId: number;
    updateRegionRequest: UpdateRegionRequest;
    xApiKey?: string | null;
}

/**
 * 
 */
export class RegionsApi extends runtime.BaseAPI {

    /**
     * Create a new region
     * Create Region
     */
    async createRegionApiRegionsPostRaw(requestParameters: CreateRegionApiRegionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RegionResponse>> {
        if (requestParameters['createRegionRequest'] == null) {
            throw new runtime.RequiredError(
                'createRegionRequest',
                'Required parameter "createRegionRequest" was null or undefined when calling createRegionApiRegionsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/regions`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRegionRequestToJSON(requestParameters['createRegionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegionResponseFromJSON(jsonValue));
    }

    /**
     * Create a new region
     * Create Region
     */
    async createRegionApiRegionsPost(requestParameters: CreateRegionApiRegionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RegionResponse> {
        const response = await this.createRegionApiRegionsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a region
     * Delete Region
     */
    async deleteRegionApiRegionsRegionIdDeleteRaw(requestParameters: DeleteRegionApiRegionsRegionIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['regionId'] == null) {
            throw new runtime.RequiredError(
                'regionId',
                'Required parameter "regionId" was null or undefined when calling deleteRegionApiRegionsRegionIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/regions/{region_id}`;
        urlPath = urlPath.replace(`{${"region_id"}}`, encodeURIComponent(String(requestParameters['regionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Delete a region
     * Delete Region
     */
    async deleteRegionApiRegionsRegionIdDelete(requestParameters: DeleteRegionApiRegionsRegionIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteRegionApiRegionsRegionIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a specific region by ID
     * Get Region
     */
    async getRegionApiRegionsRegionIdGetRaw(requestParameters: GetRegionApiRegionsRegionIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RegionResponse>> {
        if (requestParameters['regionId'] == null) {
            throw new runtime.RequiredError(
                'regionId',
                'Required parameter "regionId" was null or undefined when calling getRegionApiRegionsRegionIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/regions/{region_id}`;
        urlPath = urlPath.replace(`{${"region_id"}}`, encodeURIComponent(String(requestParameters['regionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegionResponseFromJSON(jsonValue));
    }

    /**
     * Get a specific region by ID
     * Get Region
     */
    async getRegionApiRegionsRegionIdGet(requestParameters: GetRegionApiRegionsRegionIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RegionResponse> {
        const response = await this.getRegionApiRegionsRegionIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all regions
     * Get Regions
     */
    async getRegionsApiRegionsGetRaw(requestParameters: GetRegionsApiRegionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RegionResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/regions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RegionResponseFromJSON));
    }

    /**
     * Get all regions
     * Get Regions
     */
    async getRegionsApiRegionsGet(requestParameters: GetRegionsApiRegionsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RegionResponse>> {
        const response = await this.getRegionsApiRegionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing region
     * Update Region
     */
    async updateRegionApiRegionsRegionIdPutRaw(requestParameters: UpdateRegionApiRegionsRegionIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RegionResponse>> {
        if (requestParameters['regionId'] == null) {
            throw new runtime.RequiredError(
                'regionId',
                'Required parameter "regionId" was null or undefined when calling updateRegionApiRegionsRegionIdPut().'
            );
        }

        if (requestParameters['updateRegionRequest'] == null) {
            throw new runtime.RequiredError(
                'updateRegionRequest',
                'Required parameter "updateRegionRequest" was null or undefined when calling updateRegionApiRegionsRegionIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/regions/{region_id}`;
        urlPath = urlPath.replace(`{${"region_id"}}`, encodeURIComponent(String(requestParameters['regionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRegionRequestToJSON(requestParameters['updateRegionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegionResponseFromJSON(jsonValue));
    }

    /**
     * Update an existing region
     * Update Region
     */
    async updateRegionApiRegionsRegionIdPut(requestParameters: UpdateRegionApiRegionsRegionIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RegionResponse> {
        const response = await this.updateRegionApiRegionsRegionIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
